/** A file keepr will not read, with the sentence the person is shown. */
export class ImportFileError extends Error {
	constructor(code, message) {
		super(message);
		this.name = 'ImportFileError';
		this.code = code;
	}
}

export default ImportFileError;
